export enum BestandsbuchStatus {
    ERSTELLT = 151,
    FERTIG = 152,
}
